<template>
  <d-row class="navbar bg-white no-gutters align-content-center justify-content-center border-bottom sticky-top">
    <d-col class="cols-lg-10">
      <d-row class="align-items-center justify-content-end">

        <d-col class="d-md-none d-flex">
          <a class="toggle-sidebar d-sm-inline d-md-none mr-3 menu-icon d-row my-2" @click="onShowNav">
              <i class="material-icons">menu</i>
          </a>
          <div @click="onShowNav" class="navbar-brand mr-0">
            <span class="d-md-inline">ROOSH<span class="orange">.</span></span>
          </div>
        </d-col>
        <d-col class="text-right pr-0 pr-md-1">
          <div class="user d-inline">
            <popper :options="{ placement: 'bottom', 'visible-arrow': false }" trigger="clickToToggle">
              <div class="popper-content text-left">
                <template v-if="c_isAccount">
                  <router-link class="px-0 d-block w-100 text-decoration-none btn btn-link" tag="button" :to="{ name: 'user.edit_email' }">
                    {{ $t('user.edit_email.action') }}
                  </router-link>

                  <router-link class="px-0 d-block w-100 text-decoration-none btn btn-link" tag="button" :to="{ name: 'user.edit_password' }">
                    {{ $t('user.edit_password.action') }}
                  </router-link>
                </template>

                <template v-else>
                  <router-link class="px-0 d-block w-100 text-decoration-none btn btn-link" tag="button" :to="{ name: 'user.create_account' }">
                    {{ $t('user.create_account.action') }}
                  </router-link>
                </template>

                <button @click="signOut" class="btn btn-link text-decoration-none cursor-pointer px-0 d-block w-100">
                  {{ $t('user.sign_out') }}
                </button>
              </div>

              <i class="far fa-user-circle fa-2x cursor-pointer" slot="reference" />
            </popper>
          </div>
        </d-col>

        <d-col cols="auto">
          <div>
            <locale-select />
          </div>
        </d-col>
      </d-row>
    </d-col>
  </d-row>
</template>

<script>
import LocaleSelect from '@/components/common/LocaleSelect';
import Popper from 'vue-popperjs';

export default {
  name: 'navbar',
  components: { LocaleSelect, Popper },
  props: {
    sidebar: Object
  },
  data () {
    return {
      d_isAccount: false,
    };
  },
  computed: {
    c_isAccount () {
      if (this.$oidc.userProfile && this.$oidc.userProfile.hasOwnProperty('sub')) {
        return this.$oidc.userProfile.sub.indexOf('order-') === -1;
      }

      return false;
    },
  },
  methods: {
    signOut () {
      const fullUrl = window.location;
      const appRootUrl = `${fullUrl.protocol}//${fullUrl.host}${process.env.BASE_URL}`;

      this.$oidc.signOut(
        {
          post_logout_redirect_uri: `${appRootUrl}callback`,
        }
      );
    },
    onShowNav() {
      this.sidebar.visible = true
    }
  },
};
</script>
